var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomIonInfiniteScroll',{ref:"infiniteScroll",attrs:{"disabled":_vm.disabled,"spinner":!_vm.hideSpinner && _vm.loading,"threshold":_vm.thresholdValue},on:{"ionInfinite":function($event){return _vm.$emit('onLoadMore', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }